import React from 'react';
import PropTypes from 'prop-types';

const DevelopmentDetails = ({ status, code, desc, msg }) => {
  return (
    <>
      Development mode error details:
      {status && status !== 'undefined' && <div>status: {status}</div>}
      {code && code !== 'undefined' && <div>code: {code}</div>}
      {desc && desc !== 'undefined' && <div>desc: {desc}</div>}
      {msg && msg !== 'undefined' && <div>msg: {msg}</div>}
      <br />
    </>
  );
};

DevelopmentDetails.propTypes = {
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  desc: PropTypes.string,
  msg: PropTypes.string,
};

export default DevelopmentDetails;
